import { render, staticRenderFns } from "./InputNumberComponent.vue?vue&type=template&id=8275462a&name=component-name&"
import script from "./InputNumberComponent.vue?vue&type=script&lang=js&"
export * from "./InputNumberComponent.vue?vue&type=script&lang=js&"
import style0 from "./InputNumberComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports